import {
  List,
  Datagrid,
  BooleanField,
  NumberField,
  TextField,
  DateField
} from 'react-admin';
import { TitleAboveTable } from '../../../helperComponents/TitleAboveTable';

export const AdsWriteSettingsList = (props) => {
  return (
    <>
      <TitleAboveTable title="Safety Limits" />
      <List {...props} title=" " actions={false} pagination={false}>
        <Datagrid rowClick="edit" bulkActionButtons={false} className="datagrid-content">
          <BooleanField source="kill_switch" label="Kill Switch" />
          <BooleanField source="preview_mode" label="Preview Mode" />
          <NumberField source="max_budget_change_pct" label="Max Budget Change %" />
          <NumberField source="max_bid_change_pct" label="Max Bid Change %" />
          <NumberField source="max_actions_per_account_per_day" label="Max Actions Per Account Per Day" />
          <NumberField source="max_actions_per_run" label="Max Actions Per Run" />
          <NumberField source="approval_ttl_hours" label="Approval TTL Hours" />
          <TextField source="updated_by" label="Updated By" />
          <DateField source="updated_at" label="Updated At" showTime />
        </Datagrid>
      </List>
    </>
  );
};
